import{concatMap as n}from"./concatMap.js";function r(r,t){return n((function(){return r}),t)}export{r as concatMapTo};
